// THIS FILE WAS PREVIOUSLY PART OF THE DEPRECATED REACT-PRAXIS-COMPONENTS LIBRARY.
// THE RECOMMENDED FIX FROM THE PRAXIS TEAM IS TO COPY & PASTE NEEDED COMPONENTS
// INTO YOUR PROJECT

import { string, func } from 'prop-types'
import { styled } from '@mui/material/styles'
import { Button, Grid, IconButton, Toolbar } from '@mui/material'
import ExitIcon from '@mui/icons-material/ExitToApp'

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  backgroundColor: '#666',
  color: '#fff',
  paddingLeft: '14px',
  paddingRight: '4px',
}))

const DisplayName = styled(Grid)({
  flexShrink: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

const Company = styled(Grid)({})

const SignInButton = styled(Button)({
  margin: '0 auto',
})

export const UserBar = (props) => {
  const { displayName, company, handleSignOut, handleSignIn, isAuthenticated } =
    props
  return (
    <StyledToolbar>
      {isAuthenticated() && (
        <Grid item>
          <Grid
            container
            alignContent="center"
            alignItems="center"
            justifyContent="space-between"
            wrap="nowrap"
          >
            <DisplayName item>{displayName}</DisplayName>
            <Grid item>
              <IconButton
                title="Sign Out"
                color="inherit"
                onClick={handleSignOut}
                aria-label="Sign Out"
                size="large"
              >
                <ExitIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Company item>{company}</Company>
        </Grid>
      )}
      {!isAuthenticated && (
        <SignInButton
          color="inherit"
          onClick={handleSignIn}
          aria-label="Sign In"
        >
          Sign In
        </SignInButton>
      )}
    </StyledToolbar>
  )
}

UserBar.propTypes = {
  displayName: string,
  company: string,
  handleSignIn: func,
  handleSignOut: func,
  isAuthenticated: func,
}
UserBar.defaultProps = {}

export default UserBar
